import { useWeb3React } from '@web3-react/core';

export const useEtherscanHash = (): string => {
  const url = useEtherscan();
  return `${url}/tx`;
};

export const useEtherscan = (): string => {
  const { chainId } = useWeb3React();

  if (chainId === 4) {
    return 'https://rinkeby.etherscan.io';
  } else if (chainId === 5) {
    return 'https://goerli.etherscan.io';
  } else if (chainId === 3) {
    return 'https://ropsten.etherscan.io';
  } else {
    return 'https://etherscan.io';
  }
};
